module.exports = __webpack_public_path__ + "img/verification_phone.ffd46a2b.png";